import { UploadIcon } from '@radix-ui/react-icons';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { CHARGER_FICHIER, LIST_PAIEMENT } from '../../Utils/constant';
import { store } from '../../services/service';
import { useStoreApp } from '../../store/storeApp';
export const UploadRecuPaiement = ({ paiementRef }) => {
    const [submit, setSubmit] = useState(false)
    const [fichier, setFichier] = useState([])
    const [message, setMessage] = useState("")

    const handleChangeFichier = (e) => {
        console.log(e.target.files)
        const selectedFiles = e.target.files;
        const newFiles = Array.from(selectedFiles)
        setFichier(prevFiles => [...prevFiles, ...newFiles])
    }
    const paiementListe = useStoreApp()
    return (

        <>
            <p className='text-sm text-red-600'>{message}</p>
            <label className="form-contro  w-full">
                <div className="label flex flex-col justify-start items-start gap-1.5">
                    <span className="label-text  font-medium text-gray-400">
                    </span>
                    <div className="w-full">
                        <div className="text-black py-8 border-dashed border bg-gray-50 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm "

                        >
                            <div className='flex justify-center mb-3'>
                                <UploadIcon />
                            </div>

                            <p className='text-center text-sm'>{
                                fichier.length !== 0 ? '' : 'Uploader le reçu de paiement'
                            }</p>
                            <div className='flex justify-center'>
                                <input className='text-sm mx-auto file-input-bordered mb-3 file-input file-input-ghost w-full max-w-xs' type="file" id='fichier' onChange={handleChangeFichier} />
                            </div>

                        </div>

                    </div>
                </div>
            </label>
            <button disabled={submit ? true : fichier.length === 0 ? true : false}
                className='font-mtn bg-main btn btn-sm' onClick={() => {
                    setSubmit(true)
                    store(CHARGER_FICHIER, 'multipart/form-data', { reference: paiementRef, fichier: fichier[0] }).then((res) => {
                        setSubmit(null)
                        paiementListe.getData(LIST_PAIEMENT, { page: 0, param: ``, size: 8 }, ``)
                        document.getElementById(`fermer${paiementRef}`).click()
                        toast.success('Fichier chargé avec succès')
                    }).catch((err) => {
                        console.log(err);
                        document.getElementById(`fermer${paiementRef}`).click()
                        setSubmit(false)
                        toast.error("Impossible de charger le fichier", { duration: 4000 })
                    })
                }}>
                Charger le fichier
            </button>

        </>

    )
}
